
const RE_DATE_mmddYYYY_hhmmss =
  /^([0-1]?[0-9])[/-]([0-3]?[0-9])[/-]([0-9]{4})[ ]([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?/i;
const RE_DATE_ddmmYYYY_hhmmss =
  /^([0-3]?[0-9])[/-]([0-1]?[0-9])[/-]([0-9]{4})[ ]([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?/i;
const RE_DATE_YYYYmmdd_hhmmss =
  /^([0-9]{4})[/-]([0-1]?[0-9])[/-]([0-3]?[0-9])[ ]([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?/i;
const RE_DATE_YYYYddmm_hhmmss =
  /^([0-9]{4})[/-]([0-3]?[0-9])[/-]([0-1]?[0-9])[ ]([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?/i;
const RE_DATE_hhmmss_mmddYYYY_ =
  /^([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?[ ]([0-1]?[0-9])[/-]([0-3]?[0-9])[/-]([0-9]{4})/i;
const RE_DATE_hhmmss_ddmmYYYY =
  /^([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?[ ]([0-3]?[0-9])[/-]([0-1]?[0-9])[/-]([0-9]{4})/i;
const RE_DATE_hhmmss_YYYYmmdd =
  /^([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?[ ]([0-9]{4})[/-]([0-1]?[0-9])[/-]([0-3]?[0-9])/i;
const RE_DATE_hhmmss_YYYYddmm =
  /^([0-2]?[0-9])[:]([0-5]?[0-9])[:]([0-5]?[0-9])[ ]?(AM|PM)?[ ]([0-9]{4})[/-]([0-3]?[0-9])[/-]([0-1]?[0-9])/i;

function getDateFromString(strDate) {
    let parseDate = new Date(strDate);
    if (!isNaN(parseDate.getTime())) {
        return parseDate;
    }
    const rMatch1 = RE_DATE_mmddYYYY_hhmmss.exec(strDate);
    if (rMatch1 !== null && parseInt(rMatch1[1]) <= 12) {
        let hour1 = parseInt(rMatch1[4]);
        if (hour1 === 12) {
            if (rMatch1[7] === 'AM') {
                hour1 = 0;
            }
        } else if (String(rMatch1[7]) === 'PM') {
            hour1 += 12;
        }
        return new Date(
            parseInt(rMatch1[3]),
            parseInt(rMatch1[1]),
            parseInt(rMatch1[2]),
            hour1,
            parseInt(rMatch1[5]),
            parseInt(rMatch1[6]),
        );
    }
    const rMatch2 = RE_DATE_ddmmYYYY_hhmmss.exec(strDate);
    if (rMatch2 !== null && parseInt(rMatch2[2]) <= 12) {
        let hour2 = parseInt(rMatch2[4]);
        if (hour2 === 12) {
            if (rMatch2[7] === 'AM') {
                hour2 = 0;
            }
        } else if (rMatch2[7] === 'PM') {
            hour2 += 12;
        }
        return new Date(
            parseInt(rMatch2[3]),
            parseInt(rMatch2[2]),
            parseInt(rMatch2[1]),
            hour2,
            parseInt(rMatch2[5]),
            parseInt(rMatch2[6]),
        );
    }
    const rMatch3 = RE_DATE_YYYYmmdd_hhmmss.exec(strDate);
    if (rMatch3 !== null && parseInt(rMatch3[2]) <= 12) {
        let hour3 = parseInt(rMatch3[4]);
        if (hour3 === 12) {
            if (rMatch3[7] === 'AM') {
                hour3 = 0;
            }
        } else if (rMatch3[7] === 'PM') {
            hour3 += 12;
        }
        return new Date(
            parseInt(rMatch3[1]),
            parseInt(rMatch3[2]),
            parseInt(rMatch3[3]),
            hour3,
            parseInt(rMatch3[5]),
            parseInt(rMatch3[6]),
        );
    }
    const rMatch4 = RE_DATE_YYYYddmm_hhmmss.exec(strDate);
    if (rMatch4 !== null && parseInt(rMatch4[3]) <= 12) {
        let hour4 = parseInt(rMatch4[4]);
        if (hour4 == 12) {
            if (String(rMatch4[7]) === 'AM') {
                hour4 = 0;
            }
        } else if (rMatch4[7] === 'PM') {
            hour4 += 12;
        }
        return new Date(
            parseInt(rMatch4[1]),
            parseInt(rMatch4[3]),
            parseInt(rMatch4[2]),
            hour4,
            parseInt(rMatch4[5]),
            parseInt(rMatch4[6]),
        );
    }
    const rMatch5 = RE_DATE_hhmmss_mmddYYYY_.exec(strDate);
    if (rMatch5 !== null && parseInt(rMatch5[5]) <= 12) {
        let hour5 = parseInt(rMatch5[1]);
        if (hour5 === 12) {
            if (rMatch5[4] === 'AM') {
                hour5 = 0;
            }
        } else if (String(rMatch5[4]) === 'PM') {
            hour5 += 12;
        }
        return new Date(
            parseInt(rMatch5[7]),
            parseInt(rMatch5[5]),
            parseInt(rMatch5[6]),
            hour5,
            parseInt(rMatch5[5]),
            parseInt(rMatch5[6]),
        );
    }
    const rMatch6 = RE_DATE_hhmmss_ddmmYYYY.exec(strDate);
    if (rMatch6 !== null && parseInt(rMatch6[6]) <= 12) {
        let hour6 = parseInt(rMatch6[1]);
        if (hour6 === 12) {
            if (rMatch6[4] === 'AM') {
                hour6 = 0;
            }
        } else if (String(rMatch6[4]) === 'PM') {
            hour6 += 12;
        }
        return new Date(
            parseInt(rMatch6[7]),
            parseInt(rMatch6[6]),
            parseInt(rMatch6[5]),
            hour6,
            parseInt(rMatch6[2]),
            parseInt(rMatch6[3]),
        );
    }
    const rMatch7 = RE_DATE_hhmmss_YYYYmmdd.exec(strDate);
    if (rMatch7 !== null && parseInt(rMatch7[6]) <= 12) {
        let hour7 = parseInt(rMatch7[1]);
        if (hour7 === 12) {
            if (rMatch7[4] === 'AM') {
                hour7 = 0;
            }
        } else if (String(rMatch7[4]) === 'PM') {
            hour7 += 12;
        }
        return new Date(
            parseInt(rMatch7[5]),
            parseInt(rMatch7[6]),
            parseInt(rMatch7[7]),
            hour7,
            parseInt(rMatch7[2]),
            parseInt(rMatch7[3]),
        );
    }
    const rMatch8 = RE_DATE_hhmmss_YYYYddmm.exec(strDate);
    if (rMatch8 !== null && parseInt(rMatch8[7]) <= 12) {
        let hour8 = parseInt(rMatch8[1]);
        if (hour8 === 12) {
            if (rMatch8[4] === 'AM') {
                hour8 = 0;
            }
        } else if (String(rMatch8[4]) === 'PM') {
            hour8 += 12;
        }
        return new Date(
            parseInt(rMatch8[5]),
            parseInt(rMatch8[7]),
            parseInt(rMatch8[6]),
            hour8,
            parseInt(rMatch8[2]),
            parseInt(rMatch8[3]),
        );
    }
    return null;
}

export{ getDateFromString };